// i18n namespace "faq" (spec c.7 §8; Marketing §4: SAP-first, one AI question).
// Risk fixes: "standard SAP interfaces" wording, no unsourced certification claims, no fixed durations.
// {{minutes}} is interpolated in FAQ.tsx.

export const en = {
  label: "Questions",
  title: "Before you call",
  more: "Something else? Write to us at",
  items: {
    migration: {
      q: "We are planning a move to S/4HANA. Where do you start?",
      a: "With your current landscape: what runs in ECC today, what is customized, and what the business needs to change. From there we propose an approach, a team and a plan in writing, so you can compare options before you commit.",
    },
    cfdi: {
      q: "Can you help with CFDI e-invoicing in SAP?",
      a: "Yes. We work on the SAP finance side of CFDI: configuration, the flow between SAP and your authorized provider (PAC), and the month-end controls around it. We scope the work in a written proposal.",
    },
    models: {
      q: "How can we work together?",
      a: "Three ways: senior consultants by the day or month, fixed-scope assessments at a fixed price, or direct-hire placement with a success fee. Every engagement starts with a {{minutes}}-minute call and a written proposal.",
    },
    integrator: {
      q: "Can you work alongside our current integrator?",
      a: "Yes. Our consultants can join your team or your integrator’s, in English or Spanish.",
    },
    ai: {
      q: "How do AI assistants connect to SAP?",
      a: "Through standard SAP interfaces (OData, BAPI, IDoc) and custom APIs, so the assistant can look up and update data in modules such as SD, MM and FICO. We scope each integration in a written proposal.",
    },
  },
};

export const es = {
  label: "Preguntas",
  title: "Antes de llamar",
  more: "¿Algo más? Escríbenos a",
  items: {
    migration: {
      q: "Estamos planeando migrar a S/4HANA. ¿Por dónde empiezan?",
      a: "Por tu situación actual: qué corre hoy en ECC, qué está personalizado y qué necesita cambiar el negocio. Con eso te proponemos por escrito un enfoque, un equipo y un plan, para que compares opciones antes de comprometerte.",
    },
    cfdi: {
      q: "¿Pueden ayudarnos con la facturación electrónica CFDI en SAP?",
      a: "Sí. Trabajamos la parte de finanzas SAP del CFDI: la configuración, el flujo entre SAP y tu proveedor autorizado (PAC) y los controles del cierre mensual. Definimos el trabajo en una propuesta por escrito.",
    },
    models: {
      q: "¿Cómo podemos trabajar juntos?",
      a: "De tres formas: consultores senior por día o por mes, diagnósticos de alcance fijo a precio fijo, o reclutamiento directo con cuota de éxito. Todo proyecto inicia con una llamada de {{minutes}} minutos y una propuesta por escrito.",
    },
    integrator: {
      q: "¿Pueden trabajar junto a nuestro integrador actual?",
      a: "Sí. Nuestros consultores se integran a tu equipo o al de tu integrador, en español o en inglés.",
    },
    ai: {
      q: "¿Cómo se conectan los asistentes de IA con SAP?",
      a: "Mediante interfaces estándar de SAP (OData, BAPI, IDoc) y APIs a medida, para que el asistente consulte y actualice datos en módulos como SD, MM y FICO. Definimos cada integración en una propuesta por escrito.",
    },
  },
};

export const fr = {
  label: "Questions",
  title: "Avant de nous appeler",
  more: "Autre chose ? Écrivez-nous à",
  items: {
    migration: {
      q: "Nous préparons un passage à S/4HANA. Par où commencez-vous ?",
      a: "Par votre existant : ce qui tourne aujourd’hui sous ECC, ce qui est spécifique et ce que le métier doit changer. Nous proposons ensuite par écrit une approche, une équipe et un plan, pour que vous compariez les options avant de vous engager.",
    },
    cfdi: {
      q: "Pouvez-vous nous aider sur la facturation électronique CFDI dans SAP ?",
      a: "Oui. Nous intervenons sur la partie finance SAP du CFDI : le paramétrage, le flux entre SAP et votre prestataire agréé (PAC) et les contrôles de la clôture mensuelle. Nous cadrons le travail dans une proposition écrite.",
    },
    models: {
      q: "Comment pouvons-nous travailler ensemble ?",
      a: "De trois façons : des consultants seniors à la journée ou au mois, des diagnostics à périmètre et prix fixes, ou du recrutement direct avec des honoraires de succès. Chaque mission commence par un appel de {{minutes}} minutes et une proposition écrite.",
    },
    integrator: {
      q: "Pouvez-vous travailler avec notre intégrateur actuel ?",
      a: "Oui. Nos consultants rejoignent votre équipe ou celle de votre intégrateur, en anglais ou en espagnol.",
    },
    ai: {
      q: "Comment les assistants IA se connectent-ils à SAP ?",
      a: "Via les interfaces SAP standard (OData, BAPI, IDoc) et des API sur mesure, pour que l’assistant consulte et mette à jour les données de modules comme SD, MM et FICO. Nous cadrons chaque intégration dans une proposition écrite.",
    },
  },
};

export const pt = {
  label: "Perguntas",
  title: "Antes de ligar",
  more: "Algo mais? Escreva para",
  items: {
    migration: {
      q: "Estamos planejando migrar para o S/4HANA. Por onde vocês começam?",
      a: "Pelo seu cenário atual: o que roda hoje no ECC, o que é customizado e o que o negócio precisa mudar. A partir daí propomos por escrito uma abordagem, uma equipe e um plano, para que você compare opções antes de se comprometer.",
    },
    cfdi: {
      q: "Vocês ajudam com o faturamento eletrônico CFDI no SAP?",
      a: "Sim. Trabalhamos a parte de finanças SAP do CFDI: a configuração, o fluxo entre o SAP e o seu provedor autorizado (PAC) e os controles do fechamento mensal. Definimos o trabalho em uma proposta por escrito.",
    },
    models: {
      q: "Como podemos trabalhar juntos?",
      a: "De três formas: consultores sêniores por dia ou por mês, diagnósticos de escopo fechado a preço fixo, ou recrutamento direto com taxa de sucesso. Todo projeto começa com uma ligação de {{minutes}} minutos e uma proposta por escrito.",
    },
    integrator: {
      q: "Vocês trabalham junto com o nosso integrador atual?",
      a: "Sim. Nossos consultores se juntam à sua equipe ou à do seu integrador, em inglês ou espanhol.",
    },
    ai: {
      q: "Como os assistentes de IA se conectam ao SAP?",
      a: "Por meio de interfaces padrão do SAP (OData, BAPI, IDoc) e APIs personalizadas, para que o assistente consulte e atualize dados em módulos como SD, MM e FICO. Definimos cada integração em uma proposta por escrito.",
    },
  },
};
